export type BreakPointT = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const breakpoints: Record<BreakPointT, string> = {
    xs: '320px',
    sm: '768px',
    md: '1200px',
    lg: '1440px',
    xl: '1920px',
};
